module.exports = __webpack_public_path__ + "static/media/puzzle-9-bg.2e5d0f07.svg";